module.exports = __webpack_public_path__ + "img/features-1-first_section.aa0ab00d.png";